import { fromJS } from "immutable";
import Attachment from "~/records/record.attachment.jsx";
import AttachmentMap from "~/records/record.attachment_map.jsx";
import * as actionTypes from "~/store/action_types";
import { isAttachmentFile } from "~/utils/files";

const mergeEntities = (state, newAttachments) => {
  return state.merge(newAttachments.map((a) => new Attachment(a)));
};

const attachments = (state = new AttachmentMap(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_ATTACHMENTS_SUCCESS:
    case actionTypes.ADD_NOTE_SUCCESS:
    case actionTypes.ADD_TASK_SUCCESS:
    case actionTypes.ADD_EXPENSE_SUCCESS:
    case actionTypes.ADD_DISCUSSION_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { attachments } = entities;

      if (attachments) {
        Object.keys(attachments).forEach((key) => {
          attachments[key].sizeValue = attachments[key].size;
        });
        return mergeEntities(state, fromJS(attachments));
      }

      return state;
    }
    case actionTypes.EDIT_EXPENSE_SUCCESS: {
      const { response = {}, attributes } = action;
      const { entities = {} } = response;
      const { attachments } = entities;
      const codes = attributes?.attach_uploaded_files ?? [];
      let counter = 0;
      if (attachments) {
        const updatedAttachments = Object.keys(attachments).reduce((acc, key) => {
          const attachment = attachments[key];
          if (!state.has(key)) {
            const updatedAttachment = {
              ...attachment,
              sizeValue: attachment.size,
            };
            if (counter < codes.length) {
              updatedAttachment.code = codes[counter];
              counter++;
            }
            acc[key] = updatedAttachment;
          }
          return acc;
        }, {});

        return mergeEntities(state, fromJS(updatedAttachments));
      }

      return state;
    }
    case actionTypes.FETCH_FILES_AND_ATTACHMENTS_SUCCESS: {
      const { page, response = {} } = action;
      const { entities = {} } = response;
      const { files = {} } = entities;

      const filteredAttachments = Object.fromEntries(
        Object.entries(files).filter(([_key, value]) => isAttachmentFile(value.class))
      );

      const remappedAttachments = {};
      Object.keys(filteredAttachments).forEach((key) => {
        remappedAttachments[filteredAttachments[key].id] = filteredAttachments[key];
      });

      if (remappedAttachments) {
        Object.keys(remappedAttachments).forEach((key) => {
          remappedAttachments[key].sizeValue = remappedAttachments[key].size;
        });
        return page > 1
          ? mergeEntities(state, fromJS(remappedAttachments))
          : mergeEntities(new AttachmentMap(), fromJS(remappedAttachments));
      }

      return state;
    }
    case actionTypes.DELETE_ATTACHMENT_LOADING: {
      const { id = 0 } = action;
      return id > 0 ? state.delete(`${id}`) : state;
    }
    case actionTypes.FETCH_ATTACHMENT_SUCCESS:
    case actionTypes.MOVE_ATTACHMENT_SUCCESS:
    case actionTypes.EDIT_ATTACHMENT_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { attachments = {} } = entities;
      const { single: id } = result;
      if (id > 0) {
        attachments[id].sizeValue = attachments[id].size;
        return mergeEntities(state, fromJS(attachments));
      }
      return state;
    }
    case actionTypes.DATA_OBJECT_DELETED_SUCCESS: {
      const { id, objectType } = action;

      if (isAttachmentFile(objectType)) {
        return state.delete(`${id}`);
      }

      return state;
    }
    default:
      if (action.response && action.response.entities && action.response.entities.attachments) {
        Object.keys(action.response.entities.attachments).forEach((key) => {
          action.response.entities.attachments[key].sizeValue = action.response.entities.attachments[key].size;
        });
        return mergeEntities(state, fromJS(action.response.entities.attachments));
      }

      return state;
  }
};

export default attachments;
